import { ApiCall } from "../apiBase";

/********get all Invoice query********/
export async function getAllInvoices() {
  let invoices = null;

  const result = await ApiCall({
    method: "post",
    data: {
      query: `
        query getInvoices {
          getInvoices {
            id
            billingName
            billingEmail
            price
            invoiceS3URL
            invoiceNumber
            createdAt
            status
          }
        }
      `,
    },
  });

  if (!result.data.errors && result.data.data.getInvoices) {
    invoices = result.data.data.getInvoices;
  }

  return invoices;
}
